export default __webpack_public_path__ + "static/media/cia_logo.27a57408.png";